import createIcon from '../../createIcon';

/**
 * @component @name BatchPrediction
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcgOEg3QzUuOSA4IDUgOC45IDUgMTBWMjBDNSAyMS4xIDUuOSAyMiA3IDIySDE3QzE4LjEgMjIgMTkgMjEuMSAxOSAyMFYxMEMxOSA4LjkgMTguMSA4IDE3IDhaTTEzIDIwLjVIMTFWMTlIMTNWMjAuNVpNMTMgMThIMTFDMTEgMTYuNSA4LjUgMTUgOC41IDEzQzguNSAxMS4wNyAxMC4wNyA5LjUgMTIgOS41QzEzLjkzIDkuNSAxNS41IDExLjA3IDE1LjUgMTNDMTUuNSAxNSAxMyAxNi41IDEzIDE4Wk0xOCA2LjVINkM2IDUuNjcgNi42NyA1IDcuNSA1SDE2LjVDMTcuMzMgNSAxOCA1LjY3IDE4IDYuNVpNMTcgMy41SDdDNyAyLjY3IDcuNjcgMiA4LjUgMkgxNS41QzE2LjMzIDIgMTcgMi42NyAxNyAzLjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BatchPrediction = createIcon('BatchPrediction', [
  [
    'path',
    {
      d: 'M17 8H7C5.9 8 5 8.9 5 10V20C5 21.1 5.9 22 7 22H17C18.1 22 19 21.1 19 20V10C19 8.9 18.1 8 17 8ZM13 20.5H11V19H13V20.5ZM13 18H11C11 16.5 8.5 15 8.5 13C8.5 11.07 10.07 9.5 12 9.5C13.93 9.5 15.5 11.07 15.5 13C15.5 15 13 16.5 13 18ZM18 6.5H6C6 5.67 6.67 5 7.5 5H16.5C17.33 5 18 5.67 18 6.5ZM17 3.5H7C7 2.67 7.67 2 8.5 2H15.5C16.33 2 17 2.67 17 3.5Z',
      key: '5uu4ql',
    },
  ],
]);

export default BatchPrediction;
